if (!customElements.get('bundle-quantity-selector')) {
  customElements.define(
    'bundle-quantity-selector',
    class BundleQuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.quantityInput = this.querySelector('.bundle-quantity-selector__quantity-input');
        this.addEventListener('change', this.onChange.bind(this));

        this.tiers = Array.from(this.querySelectorAll('.bundle-quantity-selector__option')).map((option) => {
          const price = option.querySelector('.bundle-quantity-selector__price-current');
          const compare = option.querySelector('.bundle-quantity-selector__price-compare');
          const badge = option.querySelector('.bundle-quantity-selector__badge');
          let planPrices = {};
          try {
            planPrices = option.dataset.planPrices ? JSON.parse(option.dataset.planPrices) : {};
          } catch (error) {
            planPrices = {};
          }
          return {
            option,
            price,
            compare,
            badge,
            planPrices,
            defaultPrice: price ? price.textContent : '',
            defaultCompare: compare ? compare.textContent : '',
            defaultCompareHidden: compare ? compare.hidden : true,
          };
        });

        const scope = this.closest('product-info') || this.closest('section');
        const purchaseOptions = scope && scope.querySelector('purchase-options');
        if (purchaseOptions && purchaseOptions.dataset.sellingPlan) {
          this.setSellingPlan(purchaseOptions.dataset.sellingPlan);
        }
      }

      onChange(event) {
        if (!event.target.matches('.bundle-quantity-selector__radio')) return;

        if (this.quantityInput) this.quantityInput.value = event.target.value;

        this.querySelectorAll('.bundle-quantity-selector__radio').forEach((radio) => {
          radio
            .closest('.bundle-quantity-selector__option')
            .classList.toggle('bundle-quantity-selector__option--selected', radio.checked);
        });
      }

      setSellingPlan(sellingPlanId) {
        this.tiers.forEach((tier) => {
          const planPrice = sellingPlanId ? tier.planPrices[sellingPlanId] : null;

          if (tier.price) tier.price.textContent = planPrice ? planPrice[0] : tier.defaultPrice;
          if (tier.compare) {
            tier.compare.textContent = planPrice ? planPrice[1] : tier.defaultCompare;
            tier.compare.hidden = planPrice ? !planPrice[1] : tier.defaultCompareHidden;
          }
          if (tier.badge) {
            tier.badge.hidden = Boolean(planPrice);
            tier.option.classList.toggle('bundle-quantity-selector__option--has-badge', !planPrice);
          }
        });
      }
    }
  );
}
